<div class="loading">
    <div class="loading-modal">
        <div class="loading-spinner">
            <mat-spinner diameter="60" strokeWidth="4"></mat-spinner>
        </div>
        <div mat-dialog-content class="loading-text">
            {{ data.message || 'Processing' }}
        </div>
    </div>
</div>